import CalendarEventOmission from './CalendarEventOmission';

const CalendarEventOmissionNames = {
    /**
     * None - the event was created and not omitted
     */
    none: CalendarEventOmission.None,

    /**
     * Event sharing from mail
     */
    unexpected: CalendarEventOmission.Unexpected,

    /**
     * Email reminder
     */
    configuration: CalendarEventOmission.Configuration,

    /**
     * Event omitted because the trust score of the entity is under the acceptable threshold
     */
    trust: CalendarEventOmission.Trust,

    /**
     * Event omitted because an error occurred when trying to create it
     */
    error: CalendarEventOmission.Error,

    /**
     * Event omitted because we are not supposed to create it, i.e. a flight cancellation
     */
    bydesign: CalendarEventOmission.ByDesign,

    /**
     * Event omitted because it was in the past
     */
    inthepast: CalendarEventOmission.InThePast,

    /**
     * Event omitted because it was shared by another user
     */
    sharedevent: CalendarEventOmission.SharedEvent,
};

export default CalendarEventOmissionNames;
